import CustomPage from './CustomPage.container';

export default CustomPage;
